import { render, staticRenderFns } from "./ResetPasswordSuccess.vue?vue&type=template&id=f5508cd8&scoped=true&"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordSuccess.vue?vue&type=style&index=0&id=f5508cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5508cd8",
  null
  
)

export default component.exports